import { useState } from 'react'

import { Button } from '../../ui'
import { COMPLIANCE_COPY } from '../monitor/compliance'
import styles from './ComplianceAlerts.module.css'

interface BannedWordEditorProps {
  onCancel: () => void
  onSave: () => void
}

function HighlightedCopy({ value }: { value: string }) {
  const [before, ...after] = value.split(COMPLIANCE_COPY.bannedWord)
  if (after.length === 0) return <>{value}</>
  return <>{before}<mark>{COMPLIANCE_COPY.bannedWord}</mark>{after.join(COMPLIANCE_COPY.bannedWord)}</>
}

export function BannedWordEditor({ onCancel, onSave }: BannedWordEditorProps) {
  const [value, setValue] = useState<string>(COMPLIANCE_COPY.bannedCopy)
  const hasBannedWord = value.includes(COMPLIANCE_COPY.bannedWord)

  return (
    <section className={styles.editor} aria-label="修改广告文案">
      <h3>修改广告文案</h3>
      <div className={styles.copyPreview}><HighlightedCopy value={value} /></div>
      <textarea aria-label="广告文案" value={value} onChange={(event) => setValue(event.target.value)} />
      <div className={styles.editorFoot}>
        <p className={hasBannedWord ? styles.editorError : styles.editorReady}>
          {hasBannedWord ? COMPLIANCE_COPY.bannedCopyHint : '高危词已移除，可以保存'}
        </p>
        <Button variant="secondary" onClick={onCancel}>取消</Button>
        <Button disabled={hasBannedWord || value.trim().length === 0} onClick={onSave}>保存</Button>
      </div>
    </section>
  )
}
